module.exports = __webpack_public_path__ + "static/media/F Pop up 1 .466dfa21.png";